import { useEffect } from 'react'
import { apiService } from '@/services/api'

type NavigationAction =
  | 'navigation.recently_viewed'
  | 'navigation.favorites'
  | 'navigation.shared_with_me'

export function useTrackNavigation(action: NavigationAction): void {
  useEffect(() => {
    apiService.trackNavigation(action).catch(() => {})
  }, [action])
}
